import type { IconAliases } from './icons';

const aliases: IconAliases = {
  itemAdd: 'fas fa-plus',
  itemMoveUp: 'fas fa-arrow-up',
  itemMoveDown: 'fas fa-arrow-down',
  itemDelete: 'fas fa-trash',
  calendarClock: 'fas fa-calendar',
  clock: 'far fa-clock',
  passwordHide: 'far fa-eye-slash',
  passwordShow: 'far fa-eye',
  validationError: 'fas fa-circle-exclamation',
};

export { aliases };
